import {
	Box,
	Button,
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { Add, Search } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Placeholder, SortableTableHeader, Subheader } from 'components';
import LessonItem from './LessonItem';
import { useLessons } from 'hooks';

const LessonList = () => {
	const navigate = useNavigate();
	const { lessons, findLessons, isLoading, isEmpty } = useLessons();

	useEffect(() => {
		findLessons();
	}, [findLessons]);

	return (
		<>
			<Subheader
				title="Lessons"
				buttons={[
					<Button
						variant="contained"
						startIcon={<Add />}
						onClick={() => navigate('/lessons/new')}
						color="primary"
					>
						Add Lesson
					</Button>
				]}
			/>
			<Container>
				<Paper>
					{!isEmpty ? (
						<TableContainer component={Paper} elevation={0}>
							<Table>
								<TableHead>
									<TableRow>
										<SortableTableHeader value="Title" />
										<SortableTableHeader value="Duration" />
										{/* Add other headers as needed */}
									</TableRow>
								</TableHead>
								<TableBody>
									{lessons.map((lesson) => (
										<LessonItem
											key={lesson.id}
											lesson={lesson}
											handleEditClick={navigate}
											handleDeleteClick={() => {
												/* handle delete */
											}}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					) : (
						<Placeholder
							icon={<Search />}
							title="No lessons"
							subtitle="Please try another search"
						/>
					)}
				</Paper>
			</Container>
		</>
	);
};

export default LessonList;
